// extracted by mini-css-extract-plugin
export var dark = "v_s7";
export var darkcookie = "v_s8";
export var tintedcookie = "v_s9";
export var regularcookie = "v_tb";
export var darkbase = "v_tc";
export var tintedbase = "v_td";
export var regularbase = "v_tf";
export var darkraw = "v_tg";
export var tintedraw = "v_th";
export var regularraw = "v_tj";
export var darkchick = "v_tk";
export var tintedchick = "v_tl";
export var regularchick = "v_tm";
export var darkherbarium = "v_tn";
export var tintedherbarium = "v_tp";
export var regularherbarium = "v_tq";
export var darkholiday = "v_tr";
export var tintedholiday = "v_ts";
export var regularholiday = "v_tt";
export var darkoffline = "v_tv";
export var tintedoffline = "v_tw";
export var regularoffline = "v_tx";
export var darkorchid = "v_ty";
export var tintedorchid = "v_tz";
export var regularorchid = "v_tB";
export var darkpro = "v_tC";
export var tintedpro = "v_tD";
export var regularpro = "v_tF";
export var darkrose = "v_tG";
export var tintedrose = "v_tH";
export var regularrose = "v_tJ";
export var darktimes = "v_tK";
export var tintedtimes = "v_tL";
export var regulartimes = "v_tM";
export var darkwagon = "v_tN";
export var tintedwagon = "v_tP";
export var regularwagon = "v_tQ";